import variableApi from '@/api/variable';

const SET_CORRELATION_DATA = 'SET_CORRELATION_DATA';
const SET_CORRELATION_DATES = 'SET_CORRELATION_DATES';

const state = {
  correlation: {
    variables: [],
    startDate: undefined,
    endDate: undefined
  }
};

const getters = {
  getCorrelationData: state => {
    return state.correlation;
  }
};

const mutations = {
  [SET_CORRELATION_DATA] (state, data) {
    state.correlation.variables = data.variables;
  },
  [SET_CORRELATION_DATES] (state, {startDate, endDate}) {
    state.correlation.startDate = startDate;
    state.correlation.endDate = endDate;
  }
};

const actions = {
  retrieveCorrelationData ({ commit }, { context, variableIds, startDate, endDate }) {
    variableApi.getCorrelationData(context, variableIds, startDate.toISOString(), endDate.toISOString()).then(data => {
      commit(SET_CORRELATION_DATES, {startDate, endDate});
      commit(SET_CORRELATION_DATA, data);
    });
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/explorerCorrelation/index.js